import { snakeCaseToWords, capitalizeFirst, capitalizeWords, capSnake, CustomNumberFormatter } from "../utility";
import * as D from 'date-fns';

export class Formatter {
  constructor(locale = 'en', currency = 'USD') {
    this.setup(locale, currency);
  }


  setup(locale, currency) {
    this.locale = locale;
    this.currency = currency;
    this.curr = (value, currency = this.currency, locale = this.locale) => {

      if (locale === 'keys') {
        locale = 'en';
      }

      const curFormatter = new Intl.NumberFormat(locale, {
        // style: 'currency',
        // currency,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });

      return curFormatter.format(value);
    };
    this.currFixed = (value, length, currency = this.currency, locale = this.locale) => {

      if (locale === 'keys') {
        locale = 'en';
      }

      return CustomNumberFormatter.fixedFormatter(length, locale, value)
    };
    this.money = (value, currency = this.currency, locale = this.locale) => {

      if (locale === 'keys') {
        locale = 'en';
      }

      const curFormatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });

      return curFormatter.format(value);
    };
    this.integer = (value, currency = this.currency, locale = this.locale) => {
      const curFormatter = new Intl.NumberFormat(locale, {
        // style: 'currency',
        // currency,
        maximumFractionDigits: 0,
      });

      return curFormatter.format(value);
    };
    this.date = (value, locale = this.locale) => {
      try {
        const date = new Date(value);
        return date.toLocaleDateString(locale);
      } catch (exception) {
        return 'Invalid Date';
      }
    };
    this.capHead = capitalizeFirst;
    this.snakeCaseToWords = snakeCaseToWords;
    this.capitalizeWords = capitalizeWords;
    this.capSnake = capSnake;

    this.i18nFormat = (value = "This Process will take approximately $$minutes$$ minutes you will receive an email addressed to $$email$$ when the process has been completed.", args = {
      minutes: 0,
      email: 'probable66@kuddusmail.com'
    }) => value.replace(/\$\$(\w+)\$\$/g, (match, variable) => {
      return args[variable] !== undefined ? args[variable] : match;
    });

  }
}
export const formatter = new Formatter();

export const DFTPlugin = (Vue) => ({
  install() {
    Vue.dft = formatter;
    Vue.prototype.$dft = formatter;
  }
})